


































import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import { i18nInObjectList } from '@/utils/i18n';
import countrys from '@/const/words/country';
import TuiGrid from 'tui-grid';
import { aHrefRenderer, textWidthButtonRenderer } from '@/utils/grid/rendererUtils';
import { namespace } from 'vuex-class';
import { i18n } from '@/main';
import { throwExternalWindowPopup } from '@/pro/helpers/popup';
import { Admin } from '@/types';
import { refreshToken } from '@/utils/dataUtils';
import { ncpPopup } from '@/utils/ncp';

const adminStore = namespace('admin');
const mallStore = namespace('mall');

const fetchCurrencySymbol = currencyCode => {
  switch (currencyCode) {
    case 'KRW':
      return '₩';
    case 'USD':
      return '$';
    case 'JPY':
      return '¥';
    default:
      return '₩';
  }
};

@Component({
  components: {
    PageTitle,
    ItemTable,
  },
})
export default class MallList extends Vue {
  @adminStore.Getter('isCommerceAccount')
  private readonly isCommerceAccount: boolean;
  @adminStore.Getter('admin')
  private readonly admin!: Admin;
  private mallArr = [];
  private onClickAddBtn(): void {
    location.href = '/mall/addForm';
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }

  private onAddingMallButtonClicked() {
    if (!this.isCommerceAccount) {
      //NOTE: 통합어드민에서 프로처럼 메세지모달로 이쁘게하기로 했어요
      if (confirm(i18n.t('MALL_LIST_MESSAGE_PAYMENT_CONTENT').toString())) {
        window.open(process.env.VUE_APP_COMMERCE_URL);
      }
      return;
    }
    this.openCommercePaymentPopup('shopbyAdd', (this.mallArr?.[0]?.mallNo ?? '').toString());
  }

  private async receiveMessage(e: MessageEvent, type) {
    if (e.data === 'commercePayComplete') {
      type === 'shopbyAdd' && (await refreshToken());
      this.getMalls();
    }
  }

  private async openCommercePaymentPopup(type, mallNo) {
    const request = {
      pathParams: { mallNo },
    };
    try {
      //NOTE : https://nhnent.dooray.com/project/pages/3503608109683620414
      const response = await this.$api.getMallsMallNoGodoAuth(request);
      throwExternalWindowPopup(`${process.env.VUE_APP_COMMERCE_URL}/order/regular-payment-popup.gd`, 'md', {
        token: response.data.token,
        shopNo: response.data.sno,
        type,
      });

      window.addEventListener('message', e => this.receiveMessage(e, type));
    } catch (err) {
      console.error(err);
    }
  }

  private openSettlementExcelPopup() {
    ncpPopup('popup/settlement-excel', 'settlementExcel', 700, 500);
  }

  // ====== For grid ========
  private tableOptions = {
    name: 'member_list',
    haveRigthBtn: true,
    havePageSizeBtn: false,
    haveExcelDownBtn: false,
  };
  private gridProps = {
    columns: [
      {
        header: 'MALL_LIST_MALL_NO',
        name: 'mallNo',
        align: 'center',
        minWidth: 60,
        renderer: props => {
          const rowData = props.grid.getRow(props.rowKey);
          const hrefInfo = {
            linkTo: {
              path: `/mall/modification/${rowData.mallNo}`,
            },
            text: rowData.mallNo,
          };
          return aHrefRenderer(hrefInfo);
        },
      },
      {
        header: 'MALL_LIST_NAME_TITLE',
        name: 'mallName',
        align: 'left',
        minWidth: 150,
        formatter: ({ row, value }) => {
          return ['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(row.globalMallType)
            ? `[글로벌${row.globalMallType === 'SEPARATED_GLOBAL_MAIN' ? 'M' : 'S'}]${value}`
            : value;
        },
      },
      {
        header: 'MALL_LIST_EXPIRATION_DUE_DAYS',
        name: 'expirationDueDays',
        align: 'center',
        minWidth: 230,
        renderer: props => {
          const { expirationDueDays, paymentDueDate, mallNo } = props.grid.getRow(props.rowKey);
          const dueDays = i18n.t('MALL_LIST_DUE_DAYS', { expirationDueDays }).toString();
          const paymentDate = i18n.t('MALL_LIST_PAYMENT_DATE', { paymentDueDate }).toString();
          const text = expirationDueDays > 0 ? dueDays + paymentDate : dueDays;
          const callback = () => {
            this.openCommercePaymentPopup('shopbyExtend', mallNo);
          };
          return textWidthButtonRenderer({
            text,
            buttonText: i18n.t('MALL_LIST_EXTENSION'),
            isShowButton: expirationDueDays <= 0,
            callback,
          });
        },
      },
      {
        header: '통화(화폐)',
        name: 'currencies',
        minWidth: 60,
        align: 'center',
        formatter: ({ value }) => {
          const currencyCode = value?.[0] ?? 'KRW';

          return `${currencyCode}(${fetchCurrencySymbol(currencyCode)})`;
        },
      },
      {
        header: 'MALL_LIST_PC_TITLE',
        name: 'pc',
        align: 'center',
        minWidth: 60,
        formatter: function(mallArr: any) {
          if (mallArr.row.url.pc.includes('http') || mallArr.row.url.pc.includes('https')) {
            return `<a href="${mallArr.row.url.pc}" target="_blank">${window.$t('MALL_LIST_GOTO_RIGHT_NOW')}</a>`;
          } else if (mallArr.row.url.pc !== '') {
            return `<a href="http://${mallArr.row.url.pc}" target="_blank">${window.$t(
              'MALL_LIST_GOTO_RIGHT_NOW',
            )}</a>`;
          }
          return null;
        },
      },
      {
        header: 'MALL_LIST_MOBILE_TITLE',
        name: 'mobile',
        align: 'center',
        minWidth: 60,
        formatter: function(mallArr: any) {
          if (mallArr.row.url.mobile.includes('http') || mallArr.row.url.mobile.includes('https')) {
            return `<a href="${mallArr.row.url.mobile}" target="_blank">${window.$t('MALL_LIST_GOTO_RIGHT_NOW')}</a>`;
          } else if (mallArr.row.url.mobile !== '') {
            return `<a href="http://${mallArr.row.url.mobile}" target="_blank">${window.$t(
              'MALL_LIST_GOTO_RIGHT_NOW',
            )}</a>`;
          }
          return null;
        },
      },
      {
        header: 'AOS App',
        name: 'android',
        align: 'center',
        minWidth: 60,
        formatter: function(mallArr: any) {
          if (mallArr.row.url.android.includes('http') || mallArr.row.url.android.includes('https')) {
            return `<a href="${mallArr.row.url.android}" target="_blank">${window.$t('MALL_LIST_SEE_APP_INFO')}</a>`;
          } else if (mallArr.row.url.android == '') {
            return '';
          }
          return `<a href="http://${mallArr.row.url.android}" target="_blank">${window.$t(
            'MALL_LIST_SEE_APP_INFO',
          )}</a>`;
        },
      },
      {
        header: 'iOS App',
        name: 'ios',
        align: 'center',
        minWidth: 60,
        formatter: function(mallArr: any) {
          if (mallArr.row.url.ios.includes('http') || mallArr.row.url.ios.includes('https')) {
            return `<a href="${mallArr.row.url.ios}" target="_blank">${window.$t('MALL_LIST_SEE_APP_INFO')}</a>`;
          } else if (mallArr.row.url.ios == '') {
            return '';
          }
          return `<a href="http://${mallArr.row.url.ios}" target="_blank">${window.$t('MALL_LIST_SEE_APP_INFO')}</a>`;
        },
      },
      {
        header: 'MALL_LIST_USED_TITLE',
        name: 'usedLabel',
        align: 'center',
        minWidth: 30,
      },
      {
        header: 'MALL_LIST_REGISTERADMIN_TITLE',
        name: 'registerAdmin',
        align: 'center',
        minWidth: 30,
        formatter: function(mallArr: any) {
          return mallArr.row.registerAdmin;
        },
      },
      {
        header: 'MALL_LIST_CREATEDDATETIME_TITLE',
        name: 'createdDateTime',
        align: 'center',
        minWidth: 90,
      },
    ],
    header: {
      height: 32,
    },
    options: {
      columnOptions: {
        resizable: true,
      },
      minRowHeight: 32,
      rowHeight: 32,
      minBodyHeight: 190,
      bodyHeight: 480,
      keyColumnName: 'mallNo',
    },
  };
  private async getMalls() {
    //NOTE 쇼핑몰 관리 : mallStatus 체크하지 않는다. = mall store 사용하지 않는 이유
    const response = await this.$api.getMalls();
    this.mallArr = response.data;
    this.mallArr.forEach(e => {
      if (e.used) {
        e.usedLabel = `${window.$t('COMMON_USE')}`;
      } else {
        e.usedLabel = `${window.$t('MALL_LIST_NOT_USE_STATE')}`;
      }
      countrys.forEach(ele => {
        if (ele.value === e.countryCode) {
          e.countryCodeLabel = `${ele.name} (${e.currencyCode})`;
        }
      });
    });

    return this.mallArr;
  }
  private beforeMount(): void {
    const noData = this.$t('MALL_LIST_SERVICE_IS_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData,
      },
    });
  }
  private mounted(): void {
    const malls = this.getMalls();

    if (this.admin.plan === 'STANDARD') {
      malls.then(([{ mallNo }]) => {
        this.$router.replace(`/mall/modification/${mallNo}`);
      });
      return;
    }

    const noData = this.$t('MALL_LIST_SERVICE_IS_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData,
      },
    });
  }
  private destroyed(): void {
    const noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData,
      },
    });
  }
}
